// The DM's log, folded with an attack's defence the DM supplied (`attack.ac`; issue 1124) — as the record the server
// stamped when it carries one: a house rule's chain followed from the outcome now known, with whom it asks (issue 1499).
import { foldAc, type RollRecord } from '@dragons-table/vtt-shared';
import type { LogEntry } from '../dice';

export function foldAttackAc(log: LogEntry[], body: { rollId: string; ac: number; record?: RollRecord | undefined }): LogEntry[] {
  return log.map((e) => (e.kind === 'roll' && e.roll.id === body.rollId && e.roll.attack ? { ...e, roll: foldAc(e.roll, body) } : e));
}
